export const deepClone = <T>(json: T): T => {
	return JSON.parse(JSON.stringify(json));
};

export const isValidJson = (json: string) => {
	try {
		JSON.parse(json);
		return true;
	} catch (e) {
		return false;
	}
};
